import React, { MouseEvent, ReactNode, forwardRef } from "react";
import { PopoverOrigin } from "@mui/material";
import { AnchorOrigin } from "../../types";
import { StyledMenu } from "./Menu.styled";

type MenuCloseEvent = {
  event: {};
  reason: "backdropClick" | "escapeKeyDown";
};

export interface MenuProps {
  children?: ReactNode;
  open: boolean;
  anchorEl?: HTMLElement | null;
  disablePortal?: boolean;
  anchorOrigin?: AnchorOrigin;
  transformOrigin?: PopoverOrigin;
  onClose?: (e: MenuCloseEvent) => void;
  onClick?: (e: MouseEvent) => void;
}

export const Menu = forwardRef<HTMLDivElement, MenuProps>((props, ref) => {
  const {
    children,
    open,
    anchorEl,
    disablePortal,
    anchorOrigin = { vertical: "bottom", horizontal: "left" },
    transformOrigin,
    onClose,
    onClick,
  } = props;

  if (children) {
    return (
      <StyledMenu
        {...props}
        ref={ref}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        open={open}
        anchorEl={anchorEl}
        disablePortal={disablePortal}
        onClose={onClose}
        onClick={onClick}
        aria-labelledby={anchorEl ? anchorEl.id : undefined}
      >
        {children}
      </StyledMenu>
    );
  }

  return null;
});
